module.exports = __webpack_public_path__ + "img/heyou_animation_svart_transparent.5461908c.gif";